import { render } from "./NewListmore.vue?vue&type=template&id=41a29e83&scoped=true"
import script from "./NewListmore.vue?vue&type=script&lang=js"
export * from "./NewListmore.vue?vue&type=script&lang=js"

import "./NewListmore.vue?vue&type=style&index=0&id=41a29e83&lang=css"
import "./NewListmore.vue?vue&type=style&index=1&id=41a29e83&scoped=true&lang=css"

import exportComponent from "D:\\CODE\\clpgaAppDevnew\\clpga_html\\f_pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41a29e83"]])

export default __exports__